'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var check = require('./check.js');
var listbuckets = require('./listbuckets.js');
var listfiles = require('./listfiles.js');
var sampledata = require('./sampledata.js');



exports.checkS3 = check.checkS3;
exports.getListBuckets = listbuckets.getListBuckets;
exports.getListFiles = listfiles.getListFiles;
exports.getSampleData = sampledata.getSampleData;
